export default class SignUpForm {
    constructor() {
        return {
            template: require('../../../../views/sign-up/organisms/o-sign-up-form.html'),
            controller: SignUpFormController,
            controllerAs: 'signUp'
        }
    }
}

class SignUpFormController {
    constructor($scope, $element, $rootScope, $location, $timeout, SignUp, Events, Translate) {
        this._scope = $scope;
        this._rootScope = $rootScope;
        this._sighUpRepo = SignUp;
        this._translateRepo = Translate;
        this._timeout = $timeout;
        this.eventHandler = Events;
        this.loading = true;
        this.awaitingConfiramtion = false;
        this.errorText = '';

        this.form = {
            first_name: '',
            last_name: '',
            email: '',
            company: '',
            phone_number: '',
            confirm_license: false
        };
        this.fields = [
            {
                name: 'first_name',
                label: 'First name',
                type: 'text',
                required: true
            },
            {
                name: 'last_name',
                label: 'Last name',
                type: 'text',
                required: true
            },
            {
                name: 'email',
                label: 'Email',
                type: 'text',
                required: true
            },
            {
                name: 'company',
                label: 'Company name',
                type: 'text',
                required: true
            },
            {
                name: 'phone_number',
                label: 'Phone number',
                required: true,
                type: 'text',
                placeholder: '+4670....'
            }
        ];

        this.isValidLink = true;
        this.invalidLinkErrorMessage = '';

        this.$onInit = () => {
            $element.addClass('o-login-form');
        }

        let code = $location.search().code;
        let sid = $location.search().session_state;
        this.isAzureSignUp = !!code;

        if (this.isAzureSignUp) {
            this._sighUpRepo.getFormData({code: code, session_state: sid})
                .then((data) => {
                    this.loading = false;
                    if (data.account_id) {
                        this.doLogin(data);
                        return;
                    }

                    this.createAzureSignUpForm(data);
                    this.isValidLink = true;
                    this.invalidLinkErrorMessage = '';
                }, (err) => {
                    this.isValidLink = false;
                    this.invalidLinkErrorMessage = err?.data?.message || 'Link is expired';
                    this.loading = false;
                });
        } else {
            this.loading = false;
        }
        this.languages = Translate.getAvailableLanguages();
    };

    createAzureSignUpForm(data) {
        this._timeout(() => {

            this.fields = [
                {
                    name: 'first_name',
                    label: 'First name',
                    errorText: '',
                    type: 'text',
                    required: true
                },
                {
                    name: 'last_name',
                    label: 'Last name',
                    errorText: '',
                    type: 'text',
                    required: true
                },
                {
                    name: 'company',
                    label: 'Company name',
                    errorText: '',
                    type: 'text',
                    required: true
                },
                {
                    name: 'phone_number',
                    label: 'Phone number',
                    errorText: '',
                    required: true,
                    type: 'text',
                    placeholder: '+4670....'
                }
            ];

            this.form.first_name = data.user.first_name;
            this.form.last_name = data.user.last_name;
            this.form.phone_number = data.user.phone_number;
            this.form.language = data.user.language || this.form.language;
            this.form.company = data.organization.company;
            this.form.meta = {
                signature: data.signature
            };
            this._translateRepo.useLanguage(this.form.language);
        });
    }

    doSignUp() {
        this.fields.forEach(field => field.errorText = null);
        this.errorText = '';
        if (this.isAzureSignUp) {
            return this.doAzureSignUp();
        }

        grecaptcha.ready(function() {
            grecaptcha.execute('6LfU9cEgAAAAAJQyWJzm8lsXRyzM_6Xk1bCce-6X', {action: 'submit'}).then(function(token) {
                this.form['recaptcha_token'] = token;
                this._sighUpRepo.register(this.form).then(() => {
                    this.awaitingConfiramtion = true;
                    this.eventHandler.flashEvent('notification', 'Registration passed');
                }, this.handleError.bind(this));
            }.bind(this));
        }.bind(this));
    };

    doAzureSignUp() {
        this._sighUpRepo.registerViaAzure(this.form).then(newSession => {
            this.doLogin(newSession);
        }, this.handleError.bind(this));
    }

    doLogin(sessionData) {
        this._rootScope.$broadcast('event:signUp.hide');
        this._rootScope.$broadcast('event:login:success', sessionData);
    }

    handleError(err) {
        let message = err.data.message || 'Sign up failed'
        let errors = err.data.errors;
        for (let key in errors) {
            this.fields.find(field => field.name === key).errorText = errors[key][0];
        }
        this.errorText = message;
    }

    clearError(field_name) {
        this.fields.find(field => field.name === field_name).errorText = '';
    }

}

